import { useEffect, useState } from "react";
import axios from "axios";
import { loadFromContentful, isContentfulConfigured } from "./contentful";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = process.env.REACT_APP_BACKEND_URL;

let cache = null;
let listeners = new Set();

export function resolveImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("/api/uploads/")) return `${BACKEND}${url}`;
  return url;
}

export async function fetchSiteContent() {
  // Try Contentful first (if configured AND has content)
  if (isContentfulConfigured) {
    const cf = await loadFromContentful();
    if (cf) {
      cache = cf;
      listeners.forEach((l) => l(cf));
      return cf;
    }
  }
  // Fallback to backend (in-app editor)
  const { data } = await axios.get(`${API}/site-content`);
  const result = { ...data, _source: "backend" };
  cache = result;
  listeners.forEach((l) => l(result));
  return result;
}

export function useSiteContent() {
  const [content, setContent] = useState(cache);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    listeners.add(setContent);
    if (!cache) {
      fetchSiteContent().finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
    return () => { listeners.delete(setContent); };
  }, []);

  return { content, loading };
}

export async function saveSiteContent(token, patch) {
  const { data } = await axios.put(`${API}/admin/site-content`, patch, {
    headers: { Authorization: `Bearer ${token}` },
  });
  cache = data;
  listeners.forEach((l) => l(data));
  return data;
}

export async function uploadImage(token, file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await axios.post(`${API}/admin/upload`, fd, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
  return data.url; // returns /api/uploads/xxx
}
